<app-layout>
  <div class="flex flex-column align-items-stretch flex-grow-1">
    <portal-progress-layout></portal-progress-layout>
    <router-outlet></router-outlet>
  </div>
  <div class="layout-footer flex justify-content-center h-4rem">
    <img src="images/brand.svg" />
  </div>
</app-layout>
